export class ShowMore {
  static isOnPage() {
    return $('.js-show-more-container').length !== 0;
  }

  constructor() {
    this.inited = false;
    this.items = [];
    this.init();
    $(window).on('resize', () => this.onResize());
  }

  onResize() {
    this.init();
  }

  onButtonClick(index, $content, $button) {
    $content.animate({ height: this.items[index].active ? 110 : this.items[index].height }, 'fast');
    $button.toggleClass('slideHide-show', !this.items[index].active);
    this.items[index].active = !this.items[index].active;
  }

  toggle(index, container) {
    $(container).find('.js-show-more-content').height('initial');
    const $container = $(container);
    const height = $container.find('.js-show-more-content').height();
    this.items[index] = {
      active: false,
      height
    };

    const $content = $container.find('.js-show-more-content');
    const $button = $container.find('.js-show-more-toggle');
    $button.removeClass('slideHide-show');
    const toggle = height > 200;

    if (toggle) {
      $content.height(110);
      $content.addClass('ContentSlide');
      $button.parents('.Button--AccordionWrap').addClass('u-display-block');
      if (!this.inited) {
        $button.on('click', () => this.onButtonClick(index, $content, $button));
      }
    } else {
      $content.removeClass('ContentSlide');
      $button.parents('.Button--AccordionWrap').remove();
    }
  }

  init() {
    $.each($('.js-show-more-container'), (index, container) => this.toggle(index, container));
    this.inited = true;
  }
}